import React from 'react';
import clsx from 'clsx';
import styles from './SchedulerTableCells.module.css';

const UrgencyCell: React.FC<{
  urgency: string | undefined;
  targetDate: string | undefined;
  isGroupRow?: boolean;
  isChildRow?: boolean;
}> = ({ urgency, targetDate, isGroupRow, isChildRow }) => {
  // For group parent rows, show centered dash
  if (isGroupRow && !isChildRow) {
    return (
      <div className={styles.urgencyCell}>
        <div className={styles.emptyCellCentered}>—</div>
      </div>
    );
  }

  const getUrgencyIndicator = (urgency: string | undefined, targetDate: string | undefined) => {
    if (urgency) {
      switch (urgency) {
        case 'critical':
          return { icon: '🔴', label: 'Critical', class: 'urgency-critical' };
        case 'late':
          return { icon: '🟡', label: 'Late', class: 'urgency-late' };
        case 'ready':
          return { icon: '🟢', label: 'Ready', class: 'urgency-ready' };
        default:
          return { icon: '⚪', label: 'Unknown', class: 'urgency-none' };
      }
    }

    if (!targetDate) {
      return { icon: '⚪', label: 'No Date', class: 'urgency-none' };
    }

    const target = new Date(targetDate);
    const today = new Date();
    const daysUntilTarget = Math.ceil((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (daysUntilTarget <= 10) {
      return { icon: '🔴', label: 'Critical', class: 'urgency-critical' };
    } else if (daysUntilTarget <= 30) {
      return { icon: '🟡', label: 'Late', class: 'urgency-late' };
    } else if (daysUntilTarget <= 60) {
      return { icon: '🟢', label: 'Ready', class: 'urgency-ready' };
    } else {
      return { icon: '⚪', label: 'Future', class: 'urgency-future' };
    }
  };

  const urgencyIndicator = getUrgencyIndicator(urgency, targetDate);
  return (
    <div className={styles.urgencyCell}>
      <span
        className={clsx(styles.urgencyIndicator, styles[urgencyIndicator.class as keyof typeof styles])}
        title={urgencyIndicator.label}
      >
        {urgencyIndicator.icon}
      </span>
    </div>
  );
};

export default UrgencyCell;
